import { render } from "./SelectUpdatedOn.vue?vue&type=template&id=5df5f85e"
import script from "./SelectUpdatedOn.vue?vue&type=script&lang=js"
export * from "./SelectUpdatedOn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__